import { Component, OnDestroy, OnInit } from '@angular/core';
import { control, olx } from 'openlayers';
import { MapComponent } from '../map.component';

@Component({
  selector: 'aol-control-fullscreen',
  template: `<ng-content></ng-content>`
})
export class ControlFullScreenComponent implements OnInit, OnDestroy {
  instance: control.FullScreen;

  constructor(private map: MapComponent) {}

  ngOnInit() {
    this.instance = new control.FullScreen(this as unknown as olx.control.FullScreenOptions);
    this.map.instance.addControl(this.instance);
  }

  ngOnDestroy() {
    this.map.instance.removeControl(this.instance);
  }
}
